import routerOptions0 from "/opt/atlassian/pipelines/agent/build/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  strict: true
}
export default {
...configRouterOptions,
...routerOptions0,
}